import Output       from '../Output';
import Color        from '../../../../Lib/Color';
import IncludeAlpha from '../Options/IncludeAlpha';

export default class Hsl extends Output {

    static availableOptions = [IncludeAlpha];

    output() {
        let hsl = Color.ensureColor(this.subject.color).hsl();

        return `hsl(${hsl.hue}, ${hsl.saturation}, ${hsl.lightness})`;
    }

}